import React from "react";
import { Dimensions, ScrollView, View } from "react-native";
import { PnmacHeadline, PnmacHtmlToNative, PnmacMediaQuery, PnmacModal, PnmacUIButton } from "pnmac-universal-components";
function ModalFaqs(_a) {
  var open = _a.open,
    closeModal = _a.closeModal,
    translations = _a.translations,
    faqData = _a.faqData,
    value = _a.value;
  return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
    queries: {
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }
  }, function (matches) {
    return /*#__PURE__*/React.createElement(PnmacModal, {
      open: open,
      closeAfterTransition: true,
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description"
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 20,
        borderRadius: 10,
        backgroundColor: "#fff",
        width: matches.small ? "100%" : "40%"
      }
    }, /*#__PURE__*/React.createElement(PnmacHeadline, {
      style: styles.title
    }, faqData), /*#__PURE__*/React.createElement(ScrollView, {
      showsVerticalScrollIndicator: false
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: value
    }), /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      idTag1: "btnModalPopupOK",
      style: styles.button,
      onPress: closeModal
    }, translations === null || translations === void 0 ? void 0 : translations.ModalPopupOkButtonText))));
  });
}
var styles = {
  title: {
    fontSize: 16,
    textTransform: "capitalize",
    color: "#000",
    fontWeight: "bold"
  },
  container: {
    padding: 20,
    borderRadius: 10,
    backgroundColor: "#fff",
    height: Dimensions.get("window").height * 0.7
  },
  button: {
    minWidth: "40%",
    marginTop: 50
  }
};
export default ModalFaqs;